import React from 'react'
import Dropzone from 'react-dropzone';
import File from './File'

// Expected props:
//   allowMultiple: a boolean that determines whether or not multiple files can be input/uploaded at once
//   filesForUpload: an array of files input by the user. Even if allowMultiple is false, this will be an array
//   categories: An array of category options as strings
//   handleCategoryUpdate: callback function for updating the category of a file
//   handleFileDrop: callback function for handling file(s) inputs
//   removeFile: callback function for removing file input by user that has not been uploaded yet
//   handleFileUpload: callback function to handle uploading files to server


const FileUploader = (props) => {
  return (
    <div id="FileUploader">
      <Dropzone
        multiple={props.allowMultiple ? true : false}
        onDrop={props.disabled ? () => null : props.handleFileDrop}
        className="uploader-container"
      >
        {({getRootProps, getInputProps}) => (
          <section className="uploader">
            <div {...getRootProps({className: 'dropzone'})}>
              <input {...getInputProps()} />
              <p>
              Drag and drop document(s) here, or click to select document(s)
              </p>
            </div>
            <aside>
              {props.filesForUpload.length > 0 ?
                <h5>
                  {props.filesForUpload.length > 1 ? "Documents:" : "Document:"}
                </h5>
                :
                null
              }
              {props.filesForUpload[0] ?
                <table style={{ width: "100%" }}>
                  <tbody>
                    {props.filesForUpload.map((file, index) => {
                      return (
                        <File
                          key={index}
                          file={file}
                          categories={props.categories}
                          removeFile={() => props.removeFile(file, index)}
                          handleFileUpload={props.handleFileUpload ? () => props.handleFileUpload(file, index) : null}
                          handleCategoryUpdate={(category) => props.handleCategoryUpdate(category, index)}
                        />
                      )
                    })}
                  </tbody>
                </table>
                : null
               }
            </aside>
          </section>
        )}
      </Dropzone>
    </div>
  )
}

export default FileUploader



// WEBPACK FOOTER //
// ./src/reuseable-components/file-uploading/FileUploader.js